import React, { useState, useRef } from 'react';
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Button } from 'primereact/button';
import CommonNav from './CommonNav'
import SubDropdown from './SubDropdown';
import DepartmentsDropdown from './DepartmentsDropdown';
import { Card } from 'primereact/card';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Messages } from "primereact/messages";
import { Endpoints } from "../constants/env/middletier";
import { Dialog } from 'primereact/dialog';

function SubstituteForm() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [editMode, setEditMode] = useState(false);
    const [loading, setLoading] = useState(false);
    const [confirmVisible, setConfirmVisible] = useState(false);

    const [inputFirstName, setInputFirstName] = useState('');

    const dropdownRef = React.useRef();

    const [formValues, setFormValues] = useState({
        firstName: '',
        lastName: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        email: '',
        phone: '',
        hireDate: '2023-07-15',
        departmentId: 2
    });

    const [selectedSub, setSelectedSub] = useState(null);

    const handleSubChange = async (sub) => {
        setSelectedSub(sub);

        if(sub) {
            setLoading(true);
            clearFormValues(sub);
            try {
              const response = await fetch(Endpoints["subsbasicinfo"] + sub.id, {
                method: "GET"
              });

              const result = await response.json();
              console.log("Success:", result);

                setFormValues({
                    firstName: result.firstName,
                    lastName: result.lastName,
                    address1: result.address1,
                    address2: result.address2,
                    city: result.city,
                    state: result.state,
                    zip: result.zip,
                    email: result.email,
                    phone: result.phone,
                    hireDate: '2023-07-15',
                    departmentId: 2
                });
            } catch (error) {
              console.error("Error getting teacher by id:", error);
            } finally {
                setLoading(false);
            }
        } else {
            clearFormValues(sub);
        }
    };

    const handleInputChange = (event) => {
        setInputFirstName(event.target.value);
    };

    const clearFormValues = (e) => {
        setFormValues({
            firstName: '',
            lastName: '',
            address1: '',
            address2: '',
            city: '',
            state: '',
            zip: '',
            email: '',
            phone: '',
            hireDate: '2023-07-15',
            departmentId: 2
        });
    }

    const handleEdit = (e) => {
        if(editMode) {
            clearFormValues(e);
        }


        setEditMode(!editMode);
    };

    const handleChange = (e) => {
//        console.log(e.target.value);
//        console.log(e.target.id);
        const { id, value } = e.target;

        setFormValues((prevValues) => ({
            ...prevValues,
            [id]: value
        }));
        console.log(formValues);
    };

    const handleNewSubSubmit = async (e) => {
        console.log('Form values:', formValues);
        e.preventDefault();
        setLoading(true);
        try {
          const response = await fetch(Endpoints["subs"], {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formValues),
          });

          const result = await response.json();
          console.log("Success:", result);

            clearFormValues();
        } catch (error) {
          console.error("Error submitting form:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleUpdateSubSubmit = async (e) => {
        console.log('Form values:', formValues);
        e.preventDefault();
        setLoading(true);
        try {
            const response = await fetch(Endpoints["subs"] + selectedSub.id, {
                method: "PUT",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(formValues),
            });

            const result = await response.json();
            console.log("Success:", result);

            clearFormValues();
            dropdownRef.current.reset()
        } catch (error) {
          console.error("Error submitting form:", error);
        } finally {
            setLoading(false);
        }
    };



    const messagesRef = useRef();
    const headerElement = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            <span className="font-bold white-space-nowrap">Substitute saved</span>
        </div>
    );

    const footerContent = (
        <div>
            <Button label="Ok" icon="pi pi-check" onClick={() => setConfirmVisible(false)} autoFocus />
        </div>
    );

//        <Card title="Substitute Info">

  return (
    <>
    <CommonNav></CommonNav>

    <br />
    <br />
    <br />
        <div className="flex flex-column align-items-center gap-5 ">
        <div className="flex flex-column gap-5 ">
            <div className="flex gap-3 justify-content-end">
                {editMode && <SubDropdown  onSubChange={handleSubChange} ref={dropdownRef}></SubDropdown>}
                {!editMode && <Button onClick={handleEdit} icon="pi pi-user-edit" text>&nbsp;Edit</Button>}
                {editMode && <Button onClick={handleEdit} icon="pi pi-ban" text>&nbsp;Cancel</Button>}
            </div>
            <div className="flex gap-3">
                <FloatLabel>
                    <InputText id="firstName" value={formValues.firstName} onChange={handleChange} />
                    <label htmlFor="firstName">First Name</label>
                </FloatLabel>
                <FloatLabel>
                    <InputText id="lastName" value={formValues.lastName} onChange={handleChange} />
                    <label htmlFor="lastName">Last Name</label>
                </FloatLabel>
            </div>
            <div className="flex gap-3">
                <FloatLabel>
                    <InputText id="address1" value={formValues.address1} onChange={handleChange} style={{ width: '429px' }} />
                    <label htmlFor="address1">Address 1</label>
                </FloatLabel>
            </div>
            <div className="flex gap-3">
                <FloatLabel>
                    <InputText id="address2" value={formValues.address2} onChange={handleChange} style={{ width: '429px' }} />
                    <label htmlFor="address2">Address 2</label>
                </FloatLabel>
            </div>
            <div className="flex gap-3">
                <FloatLabel>
                    <InputText id="city" value={formValues.city} onChange={handleChange} />
                    <label htmlFor="city">City</label>
                </FloatLabel>
                <FloatLabel>
                    <InputText id="state" value={formValues.state} onChange={handleChange} />
                    <label htmlFor="state">State</label>
                </FloatLabel>
            </div>
            <div className="flex gap-3">
                <FloatLabel>
                    <InputText id="zip" value={formValues.zip} onChange={handleChange} style={{ width: '120px' }} />
                    <label htmlFor="zip">Zip</label>
                </FloatLabel>
            </div>
            <div className="flex gap-3">
                <FloatLabel>
                    <DepartmentsDropdown id="departments" />
                    <label htmlFor="departments">Department</label>
                </FloatLabel>
            </div>
            <div className="flex gap-3">
                <FloatLabel>
                    <InputText id="email" value={formValues.email} onChange={handleChange} style={{ width: '260px' }} />
                    <label htmlFor="email">Email address</label>
                </FloatLabel>

                <FloatLabel>
                    <InputText id="phone" value={formValues.phone} onChange={handleChange} style={{ width: '150px' }} />
                    <label htmlFor="phone">Phone</label>
                </FloatLabel>
            </div>
            {loading ? ( <ProgressSpinner /> ) : ( <div></div> )}

            <div className="flex gap-3 justify-content-end">
                {!editMode && <Button onClick={handleNewSubSubmit} variant="primary">Submit</Button>}
                {editMode && <Button onClick={handleUpdateSubSubmit} variant="primary">Update</Button>}

            </div>
            <Dialog visible={confirmVisible} modal header={headerElement} footer={footerContent} style={{ width: '25rem' }} onHide={() => {if (!confirmVisible) return; setConfirmVisible(false); }}>
                <p className="m-0">

                </p>
            </Dialog>

        </div>

        </div>








    </>
  );
}

export default SubstituteForm;